import { SidebarHeader, SidebarTrigger } from '@/components/ui/sidebar'

export default function SidebarBrand() {
  return (
    <SidebarHeader className="border-b px-3 py-2">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <span className="text-lg font-bold">⟲</span>
          </div>
          <div className="flex flex-col group-data-[collapsible=icon]:hidden">
            <span className="text-sm font-semibold">Data Lineage</span>
            <span className="text-xs text-muted-foreground">Platform</span>
          </div>
        </div>
        <SidebarTrigger className="group-data-[collapsible=icon]:hidden" />
      </div>
    </SidebarHeader>
  )
}
